import React from 'react';
import { MoviesContent, FAN_FICTION_MOVIES, MoviesContentProps } from './MoviesContent';

export const FanFictionMovies = (props: MoviesContentProps) => {
  return (
    <MoviesContent
      {...props}
      pageType={FAN_FICTION_MOVIES}
      pageTypeParams={{
        filter: ['FAN_FICTION'],
        tabId: 4,
      }}
      basePageUrl="/erotic-films/fan-fiction"
    />
  );
};
